import {ThreeBarsIcon, XIcon} from '@primer/octicons-react'

import styles from './HeaderMenuToggle.module.css'

type HeaderMenuToggleProps = {
  isOpen: boolean
  onToggle: () => void
  ref?: React.Ref<HTMLButtonElement>
}

export function HeaderMenuToggle({isOpen, onToggle, ref}: HeaderMenuToggleProps) {
  return (
    <button
      ref={ref}
      type="button"
      className={styles.toggle}
      aria-label="Toggle navigation"
      aria-expanded={isOpen}
      onClick={onToggle}
    >
      {isOpen ? <XIcon size={16} /> : <ThreeBarsIcon size={16} />}
    </button>
  )
}
